import React, { useMemo } from 'react'
import { BrowserRouter, MemoryRouter } from 'react-router-dom'
import Routes from './routes'
import Navigation from '../components/Navigation'
import cx from 'classnames'
import styles from '../App.module.css'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'
const isLive = process.env.REACT_APP_MODE === 'production'

const Router: React.FC = () => {
    const { t } = useTranslation(['nav'])
    const { role } = useAuth()

    const navigationElements = useMemo(
        () =>
            role === 'admin'
                ? [
                      {
                          label: t('individualizations'),
                          path: '/individualizations',
                      },
                      { label: t('settings'), path: '/settings' },
                      { label: t('orders'), path: '/fulfillment' },
                      { label: t('subscription'), path: '/subscription' },
                  ]
                : role === 'fulfiller'
                  ? [{ label: t('orders'), path: '/fulfillment' }]
                  : [],
        [t, role]
    )

    return isLive ? (
        <MemoryRouter>
            <div className={cx(styles['zr-main-container'])}>
                <Navigation elements={navigationElements} />
                <div className={cx(styles['zr-main-content'])}>
                    <Routes />
                </div>
            </div>
        </MemoryRouter>
    ) : (
        <BrowserRouter>
            <Navigation elements={navigationElements} />
            <div className={cx(styles['zr-main-content'])}>
                <Routes />
            </div>
        </BrowserRouter>
    )
}

export default Router
